@import "~@uipath/apollo-core/src/scss/base-host.scss";
@import "../../constants/scrollbar.scss";
@import "../../utils/mixins/mixins.scss";

:host {
  display: block;
  font-family: $font-normal;

  .svg-logo-path {
    fill: var(--color-logo);
  }

  .waffle-menu-content {
    background-color: var(--color-background);
    color: var(--color-foreground);
    height: 96vh;
    display: flex;
    flex-direction: column;
    padding: $pad-xl;
  }

  .waffle-header {
    display: flex;
    justify-content: space-between;
    padding-left: $pad-xxxl;
  }

  .waffle-items-list {
    margin-top: $pad-xxxl;
    margin-left: $pad-xs;
    flex-grow: 1;
    @include scroll-on-hover();


    .more-products {
      padding-left: $pad-xxl;

      &.redesign {
        padding-left: calc($pad-xl + $pad-xxl);
      }
      @include poppins-title();
    }
  }

  .waffle-menu-res {
    width: 400px;
  }

  @media screen and (max-width: 640px) {
    .waffle-menu-res {
      width: 100vw;
    }
  }
}

:host(.redesign) {
  .waffle-menu-content {
    padding: $pad-m 0 $pad-xl;
    height: calc(100vh - ($pad-s * 2));
    box-sizing: border-box;
  }

  .waffle-header {
    align-items: center;
    justify-content: unset;
    padding-left: calc($pad-xxxl + $pad-xs);

    .logo-container {
      padding-left: 18px;
      padding-top: 6px;
    }
  }

  .waffle-items-list {
    padding-top: $pad-xxl;
    margin-left: unset;
  }

  .waffle-menu-res {
    width: 300px;
  }
}

.waffle-button {
  font-size: 100%;
  font-family: inherit;
  border: 0;
  background-color: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 0;
  height: 32px;
  width: 32px;

  &::after {
    @include after-background-effect();
    border-radius: 50%;
  }

  &:hover {
    &::after {
      background-color: var(--color-icon-default);
      opacity: 0.12;
    }
  }
}
